import { combineReducers } from "@reduxjs/toolkit";
import drugsSlice from "./drugsSlice";

export default combineReducers({
  drugs: drugsSlice,
});
